<div class="rightComp">
  <div class="progressTracker" *ngIf="questionnaireList == undefined || questionnaireList == null || questionnaireList.length <= 0"
  [ngClass]="isArabic ? 'rightAlign' : ''">
    <p>
        <span *ngIf="!isArabic">Nothing to see here!! You will see the status once an assessment been submitted.</span>
        <span *ngIf="isArabic">لا يوجد شيء هنا حاليا ً!! ستظهر حالة التقييم بمجرد تسليمه.</span>
    </p>
  </div>
    <div class="col-12 progressTracker" *ngIf="questionnaireList && questionnaireList.length > 0">
        <div class="trackerTitle mb-3" [ngClass]="isArabic ? 'rightAlign' : ''">
            <span *ngIf="!isArabic">Submitted Assessments : </span>
            <span *ngIf="isArabic">التقييمات المقدمة:</span>
        </div>
        <table class="table table-striped table-bordered customTable" *ngIf="!isArabic">
          <thead>
            <tr>
              <th>
                <span *ngIf="!isArabic">Assessment</span>
                <!-- <span *ngIf="isArabic">التقييم</span> -->
              </th>
              <th class="midAlign">
                <span *ngIf="!isArabic">Submitted On</span>
                <!-- <span *ngIf="isArabic">
                   تاريخ التقديم
                </span> -->
              </th>
              <th class="midAlign">
                <span *ngIf="!isArabic">Status</span>
                <!-- <span *ngIf="isArabic">حالة</span> -->
              </th>
              <th class="midAlign"><span>#</span></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of questionnaireList">
              <td>{{ item.questionnaireName }}</td>
              <td class="midAlign">{{ item.submittedOn}}</td>
              <td class="midAlign">{{ item.questionnaireStatus}}</td>
              <td class="midAlign showTxt" (click)="showAssessmentDetails(item)"><span *ngIf="!isArabic">View</span>
                <!-- <span *ngIf="isArabic">منظر</span> -->
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table table-striped table-bordered customTable" *ngIf="isArabic">
          <thead>
            <tr>
              <th class="midAlign"><span>#</span></th>
              <th class="midAlign">
                <span *ngIf="isArabic">حالة</span>
              </th>
              <th class="midAlign">
                <span *ngIf="isArabic">
                    تم إرساله
                </span>
              </th>
              <th class="rightAlign">
                <span *ngIf="isArabic">تقييم</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of questionnaireList">
              <td class="midAlign showTxt" (click)="showAssessmentDetails(item)">
                <span *ngIf="isArabic">منظر</span>
              </td>
              <td class="midAlign">{{ item.questionnaireStatus}}</td>
              <td class="midAlign">{{ item.submittedOn}}</td>
              <td class="rightAlign">{{ item.questionnaireName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
</div>

